// this is copy from Investigate.CaseAndEvidence.Client.Contract.Enums.VirusCheckResult 
// and will need to be updated if the enum changes in the C# code

enum VirusCheckStatus {
  ThreatDetected = 'ThreatDetected',
  NoThreat = 'NoThreat',
  CheckFailed = 'CheckFailed',
  FileTooLarge = 'FileTooLarge',
  TimeOut = 'TimeOut',
  Skipped = 'Skipped',
  VirusCheckUnavailable = 'VirusCheckUnavailable',
}

export { VirusCheckStatus };